import styled from '@emotion/styled';
import {
  space, color, layout, flexbox, typography, border,
} from 'styled-system';

const Wrapper = styled('div')`
${border}
${color}
${flexbox}
height: ${(props) => props.height};
${layout}
${space}
${typography}
width: ${(props) => props.width};
`;

export default Wrapper;
